import { Component } from 'react';
import Header from '../../Header';
import MessageLink from '../../MessageLink';
import Footer from '../../Footer';
import Lgpd from '../../Lgpd';
import ErrorBoundary from '../../ErrorHandler/ErrorBoundary';
import InfoComponent from '../InfoComponent';
import CalculadorDeduzirIR from '../../CalculadorDeduzirIR/CalculadorDeduzirIRComp';

class CalculadoraDeduzirIRPage extends Component {
	render() {
		return (
			<div>
				<ErrorBoundary><Header /></ErrorBoundary>
				<main>
					
					<InfoComponent image={"calculadora-deduzir-ir"} page={'calculadora-deduzir-ir'}></InfoComponent>	
					
					<div className="_the-content page-planos pb-10">
						<div className='container'>
							<div className="row justify-content-center">
								<div className="col-md-12">
									<div className="row row-card">
										{/* <ErrorBoundary> */}
										<CalculadorDeduzirIR></CalculadorDeduzirIR>	
										{/* </ErrorBoundary> */}
									</div>
								</div>
							</div>
						</div>
					</div>
				</main>
				{/* FOOTER */}
				<ErrorBoundary><Footer /></ErrorBoundary>
				{/* Message Link */}
				<ErrorBoundary><MessageLink /></ErrorBoundary>
				{/* LGPD */}
				<ErrorBoundary><Lgpd /></ErrorBoundary>
			</div>
		);
	}
};

export default CalculadoraDeduzirIRPage;